/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Jobs_No_Jobs_MessageInputs */

const en_candidate_jobs_no_jobs_message = /** @type {(inputs: Candidate_Jobs_No_Jobs_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are currently no open job positions.`)
};

const de_candidate_jobs_no_jobs_message = /** @type {(inputs: Candidate_Jobs_No_Jobs_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derzeit sind keine offenen Stellen verfügbar.`)
};

/**
* | output |
* | --- |
* | "There are currently no open job positions." |
*
* @param {Candidate_Jobs_No_Jobs_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_jobs_no_jobs_message = /** @type {((inputs?: Candidate_Jobs_No_Jobs_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Jobs_No_Jobs_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_jobs_no_jobs_message(inputs)
	return en_candidate_jobs_no_jobs_message(inputs)
});